import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";

import JsonPreviewEditor from "./jsonPreviewEditor";

class StylesheetEditor extends PureComponent {
	render() {
		return (
			<JsonPreviewEditor
				{...this.props}
				emptyValue={{}}
				previewPreferenceKey="stylesheet"
				previewLabel="Preview Activity"
				previewNoun="this stylesheet"
			/>
		);
	}
}

export default branch({
	activities: ["activities"],
	activitiesMap: ["activitiesMap"],
	selectedChecklistId: ["selectedChecklistId"],
	root: ["tree", "root"]
}, StylesheetEditor);
